var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotValidated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#7F9BA6",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.96,
    d: "M69.25,81.7011719 L69.25,62.9511719 L56.7988281,50.5 L69.25,38.0488281 L69.25,19.2988281 L31.75,19.2988281 L31.75,38.0488281 L44.2011719,50.5 L31.75,62.9511719 L31.75,81.7011719 L69.25,81.7011719 Z M50.5,48.8886719 L38.0488281,36.4375 L38.0488281,25.4511719 L62.9511719,25.4511719 L62.9511719,36.4375 L50.5,48.8886719 Z M62.9511719,75.5488281 L38.0488281,75.5488281 L38.0488281,64.5625 L50.5,52.1113281 L62.9511719,64.5625 L62.9511719,75.5488281 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotValidated);
export default __webpack_public_path__ + "static/media/notValidated.976819f627a9ac4cc482df51932ce264.svg";
export { ForwardRef as ReactComponent };